import useFocusOnClose from './useFocusOnClose';

export default useFocusOnClose;